/**
 * This utility function converts timestamp string into datetime string
 * @param {Number} timestamp - The varible contain datetime string generated by Date.now
 * @returns {string} - It returns a string containing date.
 */
// to get the current date derived from the Date.now()
export function getCurrentDate(timestamp) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

    // deriving the date from timestamp
    const date = new Date(timestamp);
    const day = days[date.getDay()];
    const dayOfMonth = date.getDate();
    const month = months[date.getMonth()];
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';

    // Format single-digit hours and minutes with leading zeros
    const formattedHours = (hours % 12 || 12).toString().padStart(2, '0'); // Convert 0 to 12 for AM/PM display
    const formattedMinutes = minutes.toString().padStart(2, '0');

    return `${day}, ${dayOfMonth} ${month} ${formattedHours}:${formattedMinutes} ${ampm}`;
}

/**
* validate the add note and edit note forms with the validation rules
* validation rule: 
* 1 <= title.length <= 100
* 1 <= tag.length <= 20
* 1 <= desc.length <= 1000
*/
export const validateForm = ({ title, desc, category }) => {

    return new Promise((resolve, reject) => {  // returning a promise after validation
        
        // now check that all fields follow the vallidation rules
        if (title.length < 1) reject('Invalid Title!');
        if (title.length > 100) reject("Title can't exceed 100 Characters.");

        if (desc.length < 1) reject('Invalid Description!');
        if (desc.length > 1000) reject("Description can't exceed 1000 Characters.");

        if (category.length < 1) reject('Invalid Category!');
        if (category.length > 100) reject("Category can't exceed 20 Characters.");
        
        // if no field failed validation
        resolve("All fields are valid");
    });
};
